import React, {PureComponent} from 'react';
import dayjs from 'dayjs';
import {connect, useDispatch} from 'react-redux';
import {Skeleton, Anchor, Row, Col} from 'antd';

import style from '../../css/Live.css';
import {api} from "../utils/api";
import LiveLinkItem from "../Components/LiveLinkItem";
import SortAscendingIcon from "../Components/SortAscendingIcon";
import {clearObjects, fetchLiveThreads, fetchMoreObjects, finishLoadingPage, startLoadingPage} from "../store/actions";
import {readableDate} from "../utils/helpers";
import LiveEventItem from "../Components/LiveEventItem";
import SortDescendingIcon from "../Components/SortDescendingIcon";
import LoadMoreButton from "../Components/LoadingMoreButton";

const MiniMap = ({threads}) => {
  let now = dayjs();
  let anchors = [];
  // let lastYear = now.year(), lastMonth = now.format('YYYYMM'), lastDay = now.format('YYYYMMDD');
  let lastYear = now.year(), lastMonth, lastDay;
  let counts = {};

  threads.list.map(thread => {
    let date = dayjs(thread.publish_at);
    let yearChanged, monthChanged;
    let day = date.format('YYYYMMDD')

    if (date.year() !== lastYear) {
      lastYear = date.year();
      anchors.push(['year', date.format('YYYY'), thread])
    }

    if (date.format('YYYYMM') !== lastMonth) {
      anchors.push(['month', date.format('MMMM'), thread])
      lastMonth = date.format('YYYYMM');
    }

    if (day !== lastDay) {
      anchors.push(['day', date.format('Do'), thread])
      lastDay = day;
    }

    counts[day] = (counts[day] || 0) + 1
  });

  return <div className={style.minimap_container}>
    <Anchor>
    <div className={style.minimap_list}>
      {anchors.map(([type, date, thread]) => {
        if (type === 'year') {
          return <h3 className={style.marker_year}>{date}</h3>

        } else if (type === 'month') {
          return <h4 className={style.marker_month}>{date}</h4>

        } else {
          return <Anchor.Link href={'#thread-' + thread.id} title={<span className={style.marker_day}>{date}</span> }/>
          return <div>
            <a href={'#thread-' + thread.id} className={style.marker_day}>{date}</a>
          </div>
        }
      })}
    </div>
    </Anchor>
  </div>
}

const LiveThreads = ({liveThreads, live, threadsSortAscending, onToggleSort}) => {
  let now = dayjs();
  let lastYear = now.year(), lastMonth = now.format('YYYYMM'), lastDay = now.format('YYYYMMDD');

  const dispatch = useDispatch()

  return (
    <div>
      <div className={style.threads_container}>
        {/*<div className={style.threads_toolbar}>*/}
        {/*  /!*<h4>媒体报道 <small>{live.threads_count}</small></h4>*!/*/}

        {/*  <div className="btn-group btn-group-sm btn-toolbar">*/}
        {/*    <button className="btn btn-primary">*/}
        {/*      全部*/}
        {/*      &nbsp;*/}
        {/*      <span className="badge badge-pill badge-light">{live.threads_count}</span>*/}
        {/*    </button>*/}
        {/*    <button className="btn btn-light">有视频</button>*/}
        {/*    /!*<button className="btn btn-light">评论</button>*!/*/}
        {/*    /!*<button className="btn btn-light">非评论</button>*!/*/}

        {/*  </div>*/}

        {/*  <SortAscendingIcon width={24} height={24} fill={'red'}/>*/}
        {/*</div>*/}
        {/*<hr/>*/}

        <div className={'row'}>
          <div className={'col'}>
            <div className={style.threads_list}>

              {/*<div className="float-right">*/}
              {/*  <button type={'button'} className="btn btn-link" onClick={onToggleSort}>*/}
              {/*    {threadsSortAscending ? <SortDescendingIcon width={24} height={24} fill={'red'}/> :*/}
              {/*        <SortAscendingIcon width={24} height={24} fill={'red'}/>*/}
              {/*    }*/}
              {/*  </button>*/}
              {/*</div>*/}

              {/*<input type="text"*/}
              {/*       className={['form-control', style.search_input].join(' ')}*/}
              {/*       placeholder={'过滤线索 ...'}*/}
              {/*/>*/}


              {liveThreads.refreshing ? <Skeleton active/> : null}

              {liveThreads.sections.map((section) => {
                let date = dayjs(section.data[0].publish_at);
                let isRecent = dayjs().diff(date, 'day') <= 7;

                let yearChanged, monthChanged;

                if (date.year() !== lastYear) {
                  lastYear = date.year();
                  yearChanged = true;
                }

                if (date.format('YYYYMM') !== lastMonth) {
                  lastMonth = date.format('YYYYMM');
                  monthChanged = true;
                }

                // let yearChanged = date.year() !== lastYear ? (lastYear = date.year() && true) : false;
                // let monthChanged = date.format('YYYYMM') !== lastMonth ? (lastMonth = date.format('YYYYMM') && true) : false;

                return <div className={style.threads_section + ' ' + (isRecent ? style.recent_date : '')}>
                  {/*<div className={style.marker}>*/}
                  {/*  {yearChanged ? <h3 className={style.marker_year}>{date.year()}</h3> : null}*/}
                  {/*  {monthChanged ? <h4 className={style.marker_month}>{date.format('MMMM')}</h4> : null}*/}
                  {/*  <h5 className={style.marker_day}>{date.format('MMM Do')}</h5>*/}
                  {/*</div>*/}

                  <h4 className={style.date_section_anchor}>
                    {section.title}
                    <span className={style.readable}>&nbsp; {readableDate(date)}</span>
                  </h4>

                  {section.data.map((thread) => {
                    return <LiveLinkItem thread={thread} key={thread.id}/>
                  })}
                </div>
              })}

              {/*{liveThreads.list.map((thread) => {*/}
              {/*  return <LiveLinkItem thread={thread} key={thread.id}/>*/}
              {/*})}*/}

              {liveThreads.next ?
                <LoadMoreButton
                  loading={liveThreads.loadingMore}
                  onClick={() => dispatch(fetchMoreObjects('liveThreads', liveThreads.next))}
                  hasNext={liveThreads.next}
                />
                : null}
            </div>
          </div>
          <div className={'hidden-xs'}>
            <MiniMap threads={liveThreads}/>
          </div>
        </div>
      </div>
      <br/>
      <br/>
    </div>
  )
}

class LiveDetailScreen extends PureComponent {
  state = {
    loading: false,
    live: {},
    threads: [],
    events: [],
    next: null,
    loadingMore: false,
    showTab: 'all',
    showAllEvents: true,
    eventsSortAscending: true,
    threadsSortAscending: true,
  };

  componentDidMount() {
    document.body.addEventListener('keypress', this.onKeyPress);
    if (window.innerWidth < 992) {
      this.setState({
        showAllEvents: false,
      })
    }
    this.refresh();
  }

  componentWillUnmount() {
    let {dispatch} = this.props;
    dispatch(clearObjects('liveThreads'));

    document.body.removeEventListener('keypress', this.onKeyPress);
  }

  refresh = async () => {
    let {match, dispatch} = this.props;
    let {id} = match.params;

    dispatch(startLoadingPage());
    this.setState({loading: true})

    let live = await api('GET', '/api/1/lives/' + id + '/');
    this.setState({loading: false, live, events: live.events || []});

    await this.loadThreads();
    dispatch(finishLoadingPage());
  };

  loadThreads = async () => {
    let {dispatch, match: {params: {id}}} = this.props;
    dispatch(fetchLiveThreads(id));
  }

  toggleEventSort = () => {
    let newState = !this.state.eventsSortAscending;
    let {events} = this.state;
    events = events.reverse();

    this.setState({
      eventsSortAscending: newState,
      events: [...events],
    })
  }

  toggleThreadsSort = () => {
    let newState = !this.state.threadsSortAscending;
    let {events} = this.state;

    this.setState({
      threadsSortAscending: newState,
    })
  }

  delta = 200;
  lastKeypressTime = 0;

  onKeyPress = (event) => {
    if (String.fromCharCode(event.charCode).toUpperCase() === 'E') {
      let thisKeypressTime = new Date();
      if (thisKeypressTime - this.lastKeypressTime <= this.delta) {
        let newHref = location.pathname + '/editor';
        // location.href = newHref;
        window.open(newHref, '_blank');
        thisKeypressTime = 0;
      }

      this.lastKeypressTime = thisKeypressTime;
    }
  }

  render() {
    let {match, liveThreads} = this.props;
    let {
      loading, live, events, eventsSortAscending, showAllEvents, next, loadingMore
    } = this.state;
    let lastReadableDate = null;

    let maxAuthor = null;
    let _maxCount = 0;
    let _counter = {};

    events.forEach((event) => {
      let author = event.creator.name;
      _counter[author] = (_counter[author] || 0) + 1;

      if (_counter[author] > _maxCount) {
        maxAuthor = author;
        _maxCount = _counter[author];
      }
    });

    return (
      <div className="container">
        <h1 className={style.title}>{live.title}</h1>
        <p className={style.byline}>
          王萌萌 · {dayjs(live.create_at).fromNow()}
        </p>
        <p className={style.summary}>{live.summary}</p>

        {loading ? <Skeleton active/> : null}

        <br/>
        {events && events.length ? (
            <div className="row">
              <div className="col-md-6 col-sm-12">

                <div
                  className={style.events_container + ' ' + (showAllEvents ? '' : style.events_container_collapse)}>
                  <div className={"d-flex justify-content-between align-items-center " + style.events_header}>
                    <span>由 {maxAuthor} 编辑</span>

                    <button type={'button'} className="btn btn-link" onClick={this.toggleEventSort}>
                      {eventsSortAscending ? <SortDescendingIcon width={24} height={24} fill={'red'}/> :
                        <SortAscendingIcon width={24} height={24} fill={'red'}/>
                      }
                    </button>
                  </div>

                  {showAllEvents ? null :
                    <div className={style.show_all_events_overlay}>
                      <button onClick={() => this.setState({showAllEvents: true})}
                              className={'btn text-primary'}>显示全部
                      </button>
                    </div>
                  }

                  {events.map((thread) => {
                    let _readableDate = readableDate(thread.publish_at);
                    if (lastReadableDate !== _readableDate) {
                      lastReadableDate = _readableDate;

                      return <div>
                        <time className={style.event_date_label}>
                          {_readableDate}
                          <span>&nbsp; {dayjs(thread.publish_at).format('YYYY-MM-DD')}</span>
                        </time>
                        <LiveEventItem key={'t' + thread.id} thread={thread}/>
                      </div>
                    }

                    return <LiveEventItem key={'t' + thread.id} thread={thread}/>
                  })}


                  <hr className={'d-block d-md-none'}/>
                </div>
              </div>

              <div className="col-md-6 col-sm-12">
                <div className={style.threads_section_besides_events}>
                  <LiveThreads liveThreads={liveThreads} live={live}/>
                </div>
              </div>
            </div>
          ) :


          <LiveThreads
            liveThreads={liveThreads}
            live={live}
            next={next}
            loadingMore={loadingMore}
          />

        }
      </div>
    )
  }
}

export default connect(({liveThreads}) => ({liveThreads}))(LiveDetailScreen)
